// extracted by mini-css-extract-plugin
export default {"button":"choose-button_button__9Pnxo","icon":"choose-button_icon__sxgNq","selected":"choose-button_selected__4ENBI"};